import type { RouteRecordName } from 'vue-router';

export type ProcessStep = {
  id: number;
  label: string;
  startOnPage: RouteRecordName; //this should match the route name
};

export const processSteps: ProcessStep[] = [
  { id: 1, label: 'Connect the SolShare', startOnPage: 'ConfirmTerms' },
  {
    id: 2,
    label: 'Project & site details',
    startOnPage: 'ProjectSelect',
  },
  {
    id: 3,
    label: 'Configure the SolShare',
    startOnPage: 'ConfigureSolshareConfirmSite',
  },
  { id: 4, label: 'Commission the SolShare', startOnPage: '' },
  { id: 5, label: 'Hand over', startOnPage: '' },
];
